import React from "react";
class UnavailableReservationForm extends React.Component {
  render() {
    return (
      <div id="product-reservation-form">
        <div className="product-unavailable">
          <p>This style is currently unavailable.</p>
          <p>
            <a href="/dress/search" className="standalone">
              Shop all dresses
            </a>
          </p>
        </div>
      </div>
    );
  }
}

export default UnavailableReservationForm;
